<template>
  <div>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Link Copied') }}!</v-snackbar
    >
    <h1>เชื่อมต่อช่องทางโซเชียล</h1>
    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2">
        <em class="fab fa-facebook-square mr-2" /> เชื่อมต่อกับ facebook
      </v-flex>
      <v-flex xs6>
        <div v-if="selectedBot.page_access_token" class="success--text p-2">
          {{ $t('connected') }}
        </div>
        <div v-else class="p-2">ยังไม่ได้เชื่อมต่อ</div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.page_access_token"
      class="arrow mt-2 pa-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2" style="display: inline-block">
        <v-avatar class="mr-2">
          <BotLogoManager :bot="selectedBot">
            <template #logo="{ pageLogo }">
              <img
                class="responsive-img circle"
                style="min-width: 100%"
                alt
                :src="pageLogo"
                @error="onError"
              />
            </template>
          </BotLogoManager>
        </v-avatar>
        <span>{{
          selectedBot.facebook_page_name ? selectedBot.facebook_page_name : selectedBot.pagename
        }}</span>
      </div>
    </div>

    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2">
        <em class="fab fa-instagram mr-2" /> เชื่อมต่อกับ instagram
      </v-flex>
      <v-flex xs6>
        <div v-if="selectedBot.instagram_business_account" class="success--text p-2">
          {{ $t('connected') }}
        </div>
        <div v-else class="p-2">ยังไม่ได้เชื่อมต่อ</div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.instagram_business_account"
      class="arrow mt-2 pa-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2" style="display: inline-block">
        <v-avatar class="mr-2">
          <img
            class="responsive-img circle"
            style="min-width: 100%"
            alt
            :src="pictureUrlInstagram"
            @error="onCopyError"
          />
        </v-avatar>
        <span>{{ selectedBot.instagram_name || '' }}</span>
      </div>
    </div>

    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2">
        <i class="fab fa-line mr-2" />
        {{ $t('เชื่อมต่อ Line Official Account') }}
      </v-flex>
      <v-flex xs6>
        <div
          v-if="selectedBot.line_modular_botid || selectedBot.line_access_token"
          class="success--text p-2"
        >
          {{ $t('connected') }}
        </div>
        <div v-else class="p-2">ยังไม่ได้เชื่อมต่อ</div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.line_modular_botid || selectedBot.line_access_token"
      class="arrow mt-2 pa-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2" style="display: inline-block">
        <LineProfile :pageid="selectedBot.pageid">
          <template #default="{ loading, botinfo }">
            <div v-if="loading" class="text-xs-center">
              <v-progress-circular indeterminate color="primary lighten-5"></v-progress-circular>
            </div>
            <template v-else>
              <template v-if="botinfo">
                <v-avatar class="mr-2">
                  <img
                    class="responsive-img circle"
                    style="min-width: 100%"
                    alt
                    :src="botinfo.pictureUrl || '/static/img/assets/livechat/profile.png'"
                    @error="onError"
                  />
                </v-avatar>
                <span>
                  {{ botinfo.displayName || selectedBot.line_modular_botid }}
                  <a
                    v-clipboard:copy="botinfo.basicId"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    href="javascript:void(0);"
                    style="position: relative"
                  >
                    <template v-if="botinfo.basicId">
                      ({{ botinfo.basicId }} <v-icon small color="primary">file_copy</v-icon>)
                    </template>
                  </a>
                </span>
              </template>
              <div v-else class="error--text">เกิดข้อผิดพลาด</div>
            </template>
          </template>
        </LineProfile>
      </div>
    </div>

    <template v-if="selectedBot.unlock_whatsapp">
      <v-layout wrap class="mt-3">
        <v-flex xs6 class="pt-2">
          <em class="fab fa-whatsapp mr-2" /> เชื่อมต่อกับ WhatsApp
        </v-flex>
        <v-flex xs6>
          <div v-if="selectedBot.whatsapp_account_id" class="success--text ma-2">
            {{ $t('connected') }}
            <a
              v-if="selectedBot.pageid !== `whatsapp_${selectedBot.whatsapp_account_id}`"
              href="javascript:void(0);"
              outline
              color="primary"
              @click="unlinkSocial('whatsapp')"
              >({{ $t('unlink') }})</a
            >
          </div>
          <div v-else>
            <v-btn color="#06b901" dark depressed @click="launchWhatsAppSignup">
              <i class="fab fa-whatsapp mr-2" />{{ $t('connect') }}
            </v-btn>
          </div>
        </v-flex>
      </v-layout>

      <div
        v-if="selectedBot.whatsapp_account_id"
        class="arrow mt-2"
        style="border: 1px solid #eee; border-radius: 5px"
      >
        <v-layout wrap class="ma-2">
          <template v-if="selectedBot">
            <v-flex xs12>
              <template v-if="selectedBot.whatsapp_account_id">
                <div class="mr-2" style="display: inline">
                  <img
                    class="responsive-img circle"
                    style="vertical-align: middle"
                    width="40px"
                    alt
                    :src="'/static/img/assets/icon/icon-whatsapp.png'"
                    @error="onError"
                  />
                </div>
                <span> {{ selectedBot.pagename }} ({{ selectedBot.whatsapp_account_id }}) </span>
              </template>
              <div v-else class="error--text">เกิดข้อผิดพลาด</div>
            </v-flex>
            <!-- <v-flex xs6 class="pt-2">
              <template v-if="selectedBot.whatsapp_account_id">
                <v-tooltip top>
                  <template #activator="{ on }">
                    <v-btn
                      fab
                      depressed
                      color="primary"
                      small
                      class="extra-small"
                      style="margin-top: 10px; padding: 17px"
                      v-on="on"
                      @click="shareWhatsapp"
                    >
                      <i class="fas fa-share"></i>
                    </v-btn>
                  </template>
                  <span>{{ $t('Share WhatsApp account') }}</span>
                </v-tooltip>
              </template>
            </v-flex> -->
          </template>
        </v-layout>
      </div>
    </template>

    <v-dialog v-model="showModalWhatsapp" persistent max-width="400">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="showModalWhatsapp = false">
            <v-icon> close </v-icon>
          </v-btn>
        </div>
        <v-card-text class="text-center">
          <div class="d-flex justify-center"></div>
          <qrcode-view
            class="mb-4"
            style="text-align: center"
            :value="whatsappLink"
            :size="String(180)"
            level="H"
          />
          <textarea
            ref="shareLink"
            v-model="whatsappLink"
            class="form-control pa-1"
            style="resize: vertical; width: 100%; border: 1px solid #eee"
            onclick="this.select()"
            readonly="true"
          ></textarea>
          <div class="text-xs-center">
            <v-tooltip v-model="showCopy" bottom color="success">
              <template #activator="{}">
                <v-btn
                  v-clipboard:copy="whatsappLink"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                  depressed
                  color="primary"
                >
                  <span class="glyphicon glyphicon-file mr-1"></span>
                  {{ $t('copy') }}
                </v-btn>
              </template>
              <span>{{ $t('Copied') }}</span>
            </v-tooltip>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-layout v-if="isFacebookShop" wrap class="mt-3">
      <v-flex xs6 class="pt-2">
        <i class="fab fa-facebook-square mr-2" />
        {{ $t('live_meta.connect_meta_catalog') }}
      </v-flex>
      <v-flex xs6>
        <div v-if="Boolean(selectedBot.facebook_smc_catalog_id)" class="success--text p-2">
          {{ $t('connected') }}
          <a href="javascript:void(0);" outline color="primary" @click="unlinkMetaCatalog">
            ({{ $t('unlink') }})
          </a>
        </div>
        <div v-else class="p-2">
          <v-btn color="primary" :href="metaCatalogUrl">
            {{ $t('connect') }}
          </v-btn>
        </div>
      </v-flex>
      <v-flex
        v-if="Boolean(selectedBot.facebook_smc_catalog_id)"
        xs12
        class="arrow pa-4 my-2"
        style="border: 1px solid #eee; border-radius: 5px"
      >
        <div>
          Catalog ID:
          <span class="primary--text" style="font-weight: 500">{{
            selectedBot.facebook_smc_catalog_id || '-'
          }}</span>
        </div>
      </v-flex>
      <v-flex v-if="!Boolean(selectedBot.facebook_smc_catalog_id)" xs12>
        <div class="py-2">
          {{ $t('live_meta.meta_catalog_verify') }}
          <a
            :href="`https://business.facebook.com/bizkit/shopping-on-messenger/pre-onboarding/${
              selectedBot.facebook_page_id || selectedBot.pageid
            }`"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t('live_meta.verify') }}
          </a>
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="py-2">
          {{ $t('live_meta.meta_catalog_available') }}
          <a href="https://blog.zwiz.app/meta-catalog/" target="_blank" rel="noopener noreferrer">
            {{ $t('read_tutorial') }}
          </a>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AES from 'crypto-js/aes'
import config from '@/config'
import QrcodeView from 'qrcode.vue'

import facebookApi from '@/api/facebook'
import { handleResponse } from '@/api/util'
import whatsappApi from '@/api/whatsapp'
import BotLogoManager from '@/components/elements/BotLogoManager.vue'
import LineProfile from '@/components/elements/LineProfile.vue'

import { FEATURE } from '@/constants/feature.js'
export default {
  components: {
    BotLogoManager,
    LineProfile,
    QrcodeView
  },
  data() {
    return {
      lineUrl: '',
      facebookUrl: '',
      showPageList: false,
      pictureUrlInstagram: '',
      showCopy: false,
      whatsappLink: '',
      showModalWhatsapp: false,
      metaCatalogUrl: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      availablePages: 'availablePages'
    }),
    isFacebookShop() {
      return (this.selectedBot.features || '').split(',').includes(FEATURE.FACEBOOK_SHOP)
    }
  },

  async mounted() {
    let line_connect_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }/connectline`
    let fb_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }/autofblogin`

    this.getInstagramDetail()
    let query = []

    let state = {
      userid: this.$store.state.userid,
      pageid: this.selectedBot.pageid,
      lang: this.currentLang,
      type: 'connect'
    }

    for (const key in state) {
      if (key != 'state' && key) query.push(`${key}=${state[key]}`)
    }

    let querystring = query.join(',')

    this.facebookUrl = `https://www.facebook.com/v10.0/dialog/oauth?client_id=${
      config.appid
    }&scope=${
      config.fb_scope
    }&return_scopes=true&response_type=token&redirect_uri=${encodeURIComponent(fb_redirect_uri)}`
    if (query && query.length > 0) this.facebookUrl = this.facebookUrl + `&state={${querystring}}`

    let encrypt_query = ''

    encrypt_query = AES.encrypt(querystring, 'awesomezwizai').toString()

    //client id
    //sme 1656036711
    //enterpise 1656186798
    this.lineUrl = `https://manager.line.biz/module/auth/v1/authorize?response_type=code&client_id=1656186798&redirect_uri=${line_connect_redirect_uri}&scope=account:manage%20message:mark_as_read%20message:receive%20message:send%20profile:read&state=${encrypt_query}`

    const metaCataLogConfig = `${JSON.stringify({ lang: this.currentLang })}`
    const metaCatalogRedirectUri = `${window.location.origin}/callback/meta-catalog`
    this.metaCatalogUrl = `https://www.facebook.com/dialog/oauth?client_id=${config.appid}&display=page&extras=%7B%22business_config%22%3A%7B%22business%22%3A%7B%22name%22%3A%22example-business-name%22%7D%7D%2C%22repeat%22%3Afalse%2C%22setup%22%3A%7B%22business_vertical%22%3A%22ECOMMERCE%22%2C%22channel%22%3A%22STRUCTURED_MESSAGING_COMMERCE%22%2C%22currency%22%3A%22THB%22%2C%22external_business_id%22%3A%22${this.selectedBot.pageid}%22%2C%22timezone%22%3A%22Asia%2FSingapore%22%7D%7D&redirect_uri=${metaCatalogRedirectUri}&response_type=code&scope=catalog_management%2Cmanage_business_extension&state=${metaCataLogConfig}`
    if (this.$route.hash === '#meta-catalog-success') {
      const result = await this.$swal.fire({
        title: this.$t('connected'),
        type: 'success',
        confirmButtonText: this.$t('live_meta.upload_product'),
        cancelButtonText: this.$t('live_meta.for_later'),
        showCancelButton: true,
        reverseButtons: true
      })
      if (result && result.value) {
        this.$router.push({
          path: `/${this.currentLang}/template`,
          query: {
            tab: 'Products'
          }
        })
      } else {
        this.$router.replace({
          path: `/${this.currentLang}/billing`,
          query: {
            tab: 'social-connect-management'
          }
        })
      }
    }
  },
  methods: {
    async shareWhatsapp() {
      if (!this.selectedBot.whatsapp_account_id) return
      try {
        const { result } = await this.get(`whatsapp/phone-numbers`, {
          params: {
            whatsapp_account_id: this.selectedBot.whatsapp_account_id
          }
        })
        if (result && result.data) {
          const findData = result.data.find((data) => data.quality_rating === 'GREEN')
          if (findData && findData.display_phone_number) {
            this.whatsappLink = `https://wa.me/${findData.display_phone_number.replace(
              /[^a-zA-Z0-9]/g,
              ''
            )}`
            // console.log('this.whatsappLink: ', this.whatsappLink)
            this.showModalWhatsapp = true
          }
        }
        // this.whatsappLink = 'https://wa.me/66655136972'
        // this.showModalWhatsapp = true
      } catch (error) {
        console.error(error)
      }
    },
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onCopyError: function () {},
    async unlinkSocial(channel) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to disconnect this social from this chatbot?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        try {
          let response = await whatsappApi.deleteUnlinkApp({
            config: {
              params: {
                pageid: this.selectedBot.pageid,
                app: channel
              }
            }
          })
          if (response.success) {
            await this.$swal.fire({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm')
            })
          }
          window.location.reload()
        } catch (error) {
          console.error(error)
        }
      }
    },
    launchWhatsAppSignup() {
      const vm = this
      // Launch Facebook login
      window.FB.login(
        async function (response) {
          if (response.authResponse) {
            const accessToken = response.authResponse.accessToken
            console.log('Completed with token ' + accessToken)
            //const accessToken = 'EAAEmyCJUnzwBAOZBG74ozQb3TZAuqN5seWlxVPZClzCD5J1MpKsuhmmh12ZCQCGQtXAGrZCkphd0jodZBqwZCgMVMJvMZBtdtbMY18PlpL2ZAtc41GswRDrhbNSPIUr4aUl1YmIIVkanRKjFQqOwASBIdjRfZBJ39QWFKXxrpIa9iRa26Gd8vEVNzV6LVMYjcI1gIpJYzsrizxEYV9RtuGPlWb'
            try {
              let res = await whatsappApi.postNewSubscribe({
                body: {
                  pageid: vm.selectedBot.pageid,
                  access_token: accessToken
                }
              })
              if (res.status == 200 && res.data && res.data.success) {
                await vm.$swal.fire({
                  title: vm.$t('Success'),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm')
                })
              } else {
                await vm.$swal.fire({
                  type: 'error',
                  title: vm.$t('Error')
                })
              }
              window.location.reload()
            } catch (error) {
              let errorMessage = ''
              if (
                error.response &&
                error.response.data &&
                error.response.data.result &&
                error.response.data.result.error
              ) {
                errorMessage = error.response.data.result.error.message || 'error'
              }
              await vm.$swal.fire({
                type: 'error',
                title: vm.$t('Error'),
                text: errorMessage
              })
              window.location.reload()
            }
            //Use this token to call the debug_token API and get the shared WABA's ID
          } else {
            console.log('User cancelled login or did not fully authorize.')
          }
        },
        {
          scope: 'business_management,whatsapp_business_management,whatsapp_business_messaging',
          extras: {
            feature: 'whatsapp_embedded_signup',
            setup: {
              // Prefilled data can go here
            }
          }
        }
      )
    },
    async getInstagramDetail() {
      let response = await facebookApi.getInstagramDetail({
        params: {
          access_token: this.$store.state.selectedBot.page_access_token
        }
      })
      await handleResponse(response)
      if (response && response.instagram_business_account) {
        this.pictureUrlInstagram = response.instagram_business_account.profile_picture_url
      }
    },
    async onConfirmSubscribe(page) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to connect this social to this chatbot?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let data = {
          adminid: this.$store.state.userid,
          pageid: this.selectedBot.pageid,
          page_access_token: page.access_token,
          type: 'connect_facebook_page'
        }
        try {
          let response = await this.post('admin/connect', data, {}, false)
          if (response.success) {
            await this.$swal.fire({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm')
            })
          }
          window.location.reload()
        } catch (error) {
          console.error(error)
        }
        this.showPageList = false
      }
    },
    logout() {
      var isFacebook = this.isFacebook
      this.$store.dispatch('logout', null).then()
      if (isFacebook) {
        this.$router.push('/' + this.currentLang + '/login')
      } else {
        this.$router.push('/' + this.currentLang + '/nigol')
      }
    },
    onError: function (event) {
      event.target.src = '/static/img/assets/livechat/profile.png'
    },
    async unlinkMetaCatalog() {
      try {
        await this.$store.dispatch('disconnectMetaCatalog')
      } catch (err) {
        await this.$swal.fire({
          title: this.$t('Error'),
          text: err,
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          reverseButtons: true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/SocialConnect.vue